module.exports = __webpack_public_path__ + "img/contact.f2b77fe7.png";